import React, { useEffect, useState } from 'react';
import FormInput from '../../components/form_elements/form-input';
import FormCheckbox from '../../components/form_elements/form-checkbox';
import { useFormContext } from 'react-hook-form';
import { formatCurrency } from '../../components/formatters';
import { useSelector } from 'react-redux';
import useMsalApi from '../../components/use-msal-api';
import { DependentRelationship } from '../../components/enums/dependent-relationship';

const InsurancePlans = ({plan, fieldLabel, fieldDescription, fieldName, amountName, unmodifiedAmount, amountDescription, incrementAmount, disabled,reset}) => {
    const {watch, getValues, setValue, trigger} = useFormContext(); 
    const watcher = watch(fieldName);
    const [checkDisabled, setCheckDisabled] = useState(false);
    const [callApi] = useMsalApi();
    const enrollments = useSelector(s => s.enrollments);
    const [dedAmount, setDedAmount] = useState();

    useEffect(() => {
        if (Array.isArray(enrollments) || plan.length === 0) 
            return;

        const selection = enrollments.selections.find(s => s.planType === plan.planType);

        if(!selection)
            return;
        setValue(fieldName, !!selection);
        trigger(fieldName);

        if(selection?.amount) {
            calculateDeduction(selection?.amount)           
            setValue(amountName, selection?.amount);
            trigger(amountName);
        }
        setTimeout(function(){
            var isChecked = setChecked(enrollments.selections.find(s => s.planType === plan.planType));
            setValue(fieldName, isChecked);
            trigger(fieldName);
            trigger(amountName);
        }, 500);

    }, [enrollments, plan, reset]);

    useEffect(() => {
        setCheckDisabled(!watcher);
        trigger(fieldName);
        trigger(amountName);
    }, [watcher, reset])

    useEffect(() => {
        if(disabled === true){
            setValue(fieldName, false);
            trigger(fieldName);
        }
    }, [disabled])

    const calculateDeduction = async (e) => {
        var birthdate = 0;
        if(fieldName === "spouseBenefit"){
            if(enrollments.contacts.filter(s => DependentRelationship.SignificantOther.includes(s.relationship.id)).length > 1) { 
                birthdate = enrollments.contacts.filter(s => DependentRelationship.SignificantOther.includes(s.relationship.id)).find(s=> enrollments.dependents.find(d=> s.id === d)).birthdate;
            }else{
                birthdate = enrollments?.contacts?.find(s => DependentRelationship.SignificantOther.includes(s.relationship.id))?.birthdate;
            }         
        }else{
            birthdate = enrollments.employee.birthdate;
        }

        if(!e){
            setDedAmount(null);
            return;
        }
        var params = {
            coverageAmount: e,
            effectiveDate: enrollments.effectiveDate,
            
            birthDate : birthdate,
            planId : plan.id
        }
        var results = await callApi(`VoluntaryLife`, "POST", params);
        if(!results.error)
            setDedAmount(results);

    }

    const setChecked = (selection) => {
        if(!selection?.amount || selection?.amount === 0){
            return false;
        }

        return true;
    }


    
    return ( 
        <div className='mb-6'>
            <div key={plan.id} className="checkbox-title">
                <FormCheckbox label={<span className='font-bold text-lg'>{fieldLabel}</span>} name={fieldName} disabled={disabled} />
                <div className='ml-8 mt-2'>
                    <div className='mb-4'>{fieldDescription}</div>
                    {checkDisabled || disabled ? <></>
                    :
                    <>
                    <FormInput type="currency" 
                        name={amountName} 
                        label={`Enter coverage amount in increments of ${formatCurrency(incrementAmount, 0)}`} 
                        helperText={amountDescription} 
                        disabled={checkDisabled} 
                        props={{step: incrementAmount}} 
                        onChange={calculateDeduction}
                    />
                    {dedAmount ?
                        <>
                        <div className='mt-4'>Paycheck Deduction: ${dedAmount?.toFixed(2).toLocaleString()} 
                        </div>
                        {fieldName !== 'childBenefit' && ((unmodifiedAmount ?? 0) < getValues(amountName)) ?
                        <div className='pt-2'><span className='text-gray-400'>*Paycheck deductions will not change until the carrier approves coverage</span>
                        </div> : <></> }
                        </>
                        : <></>
                    }
                    </>
                    }
                </div>
            </div>
        </div>
     );
}
 
export default InsurancePlans;